// Copyright (c) Move Closer 2022.

import { WindowService } from '@movecloser/front-core'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl> (edited)
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function loadLeaflet (): Promise<any> {
  if (!WindowService.isDefined) {
    throw new Error('[Leaflet]: Trying to load leaflet at node environment.')
  }

  // eslint-disable-next-line
  return await new Promise<any>(async (resolve, reject) => {
    try {
      const Leaflet = await import(/* webpackChunkName: "leaflet" */ 'leaflet').then(
        async () => {
          // await import(
          //   // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //   // @ts-ignore
          //   /* webpackChunkName: "leaflet.utils" */ 'leaflet.markercluster'
          //   )
          //
          // await import(
          //   // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //   // @ts-ignore
          //   /* webpackChunkName: "leaflet.utils" */ 'leaflet-edgebuffer'
          //   )

          // eslint-disable-next-line
          return (window as any).L
        }
      )

      resolve(Leaflet)
    } catch (e) {
      reject(e)
    }
  })
}
